import React from "react";
import { Link } from "react-router-dom";
import { AnimatedSection } from "../components/IntersectionObserver.tsx";
import { ArrowLeft } from "lucide-react";
import Logo from "../components/Logo.tsx";

const TermsOfUsePage: React.FC = () => {
  return (
    <div className="legal-page">
      {/* Header */}
      <header className="legal-header">
        <div className="dark-container">
          <div className="legal-header-content">
            <Logo size="medium" />
            <Link to="/" className="back-button">
              <ArrowLeft size={20} />
              <span>На главную</span>
            </Link>
          </div>
        </div>
      </header>

      {/* Content */}
      <main className="legal-content">
        <div className="dark-container">
          <AnimatedSection>
            <div className="legal-document">
              <h1 className="display-medium">Условия использования</h1>
              <p className="body-medium legal-updated">Последнее обновление: {new Date().toLocaleDateString('ru-RU', { year: 'numeric', month: 'long', day: 'numeric' })}</p>

              <section className="legal-section">
                <h2 className="heading-2">1. Принятие условий</h2>
                <p className="body-medium">
                  Добро пожаловать на сайт AGK Commerce (далее — «Сайт»). Используя наш Сайт, вы соглашаетесь с настоящими Условиями использования (далее — «Условия»). Если вы не согласны с какими-либо из этих Условий, пожалуйста, не используйте наш Сайт.
                </p>
                <p className="body-medium">
                  Настоящие Условия представляют собой юридически обязывающее соглашение между вами и AGK Commerce. Мы оставляем за собой право изменять эти Условия в любое время, и ваше дальнейшее использование Сайта будет означать принятие обновленных Условий.
                </p>
              </section>

              <section className="legal-section">
                <h2 className="heading-2">2. Описание услуг</h2>
                <p className="body-medium">
                  AGK Commerce предоставляет услуги по разработке премиальных интернет-магазинов для модных брендов, включая:
                </p>
                <ul className="body-medium legal-list">
                  <li>Разработку индивидуальных e-commerce решений</li>
                  <li>UX/UI дизайн и брендинг</li>
                  <li>Техническую интеграцию с ERP/CRM системами</li>
                  <li>Консультационные услуги в сфере e-commerce</li>
                  <li>Техническую поддержку и сопровождение проектов</li>
                </ul>
                <p className="body-medium">
                  Конкретные условия предоставления услуг определяются индивидуальными договорами с каждым клиентом.
                </p>
              </section>

              <section className="legal-section">
                <h2 className="heading-2">3. Использование сайта</h2>
                <p className="body-medium">При использовании нашего Сайта вы обязуетесь:</p>
                <ul className="body-medium legal-list">
                  <li>Предоставлять достоверную и актуальную информацию при заполнении форм</li>
                  <li>Не использовать Сайт для незаконных целей или нарушения прав третьих лиц</li>
                  <li>Не пытаться получить несанкционированный доступ к системам или данным</li>
                  <li>Не распространять вредоносное программное обеспечение</li>
                  <li>Не нарушать работу Сайта или создавать чрезмерную нагрузку на его ресурсы</li>
                  <li>Соблюдать все применимые законы и нормативные акты</li>
                </ul>
              </section>

              <section className="legal-section">
                <h2 className="heading-2">4. Интеллектуальная собственность</h2>
                <p className="body-medium">
                  Все материалы, представленные на Сайте, включая текст, графику, логотипы, изображения, аудио- и видеоматериалы, программное обеспечение и другой контент (далее — «Контент»), являются собственностью AGK Commerce или наших лицензиаров и защищены законами об авторском праве, товарных знаках и других правах интеллектуальной собственности.
                </p>
                <p className="body-medium">
                  Вам предоставляется ограниченная, неисключительная, непередаваемая лицензия на доступ и использование Сайта исключительно в личных некоммерческих целях. Запрещается:
                </p>
                <ul className="body-medium legal-list">
                  <li>Копировать, воспроизводить или распространять Контент без письменного разрешения</li>
                  <li>Модифицировать или создавать производные работы на основе Контента</li>
                  <li>Использовать Контент в коммерческих целях</li>
                  <li>Удалять или изменять уведомления об авторских правах или товарных знаках</li>
                </ul>
              </section>

              <section className="legal-section">
                <h2 className="heading-2">5. Пользовательский контент</h2>
                <p className="body-medium">
                  Если вы отправляете нам какую-либо информацию, отзывы, предложения или материалы через контактные формы или другие каналы связи (далее — «Пользовательский контент»), вы предоставляете AGK Commerce неисключительное право использовать такой контент для целей улучшения наших услуг.
                </p>
                <p className="body-medium">
                  Вы гарантируете, что Пользовательский контент:
                </p>
                <ul className="body-medium legal-list">
                  <li>Не нарушает прав третьих лиц</li>
                  <li>Не содержит незаконного, оскорбительного или вредоносного контента</li>
                  <li>Не содержит вирусов или другого вредоносного кода</li>
                </ul>
              </section>

              <section className="legal-section">
                <h2 className="heading-2">6. Конфиденциальность</h2>
                <p className="body-medium">
                  Использование вами нашего Сайта также регулируется нашей <Link to="/privacy-policy" className="legal-link">Политикой конфиденциальности</Link>, которая включена в настоящие Условия посредством ссылки. Пожалуйста, ознакомьтесь с Политикой конфиденциальности для получения информации о том, как мы собираем, используем и защищаем ваши персональные данные.
                </p>
              </section>

              <section className="legal-section">
                <h2 className="heading-2">7. Ссылки на сторонние сайты</h2>
                <p className="body-medium">
                  Наш Сайт может содержать ссылки на сторонние веб-сайты или ресурсы. Эти ссылки предоставляются исключительно для вашего удобства. Мы не контролируем содержание этих сайтов и не несем ответственности за их содержание, доступность или любые убытки, возникшие в результате их использования.
                </p>
              </section>

              <section className="legal-section">
                <h2 className="heading-2">8. Отказ от гарантий</h2>
                <p className="body-medium">
                  Сайт и все материалы на нем предоставляются «как есть» без каких-либо гарантий, явных или подразумеваемых. В максимальной степени, разрешенной применимым законодательством, мы отказываемся от всех гарантий, включая, но не ограничиваясь:
                </p>
                <ul className="body-medium legal-list">
                  <li>Гарантии товарной пригодности и пригодности для конкретной цели</li>
                  <li>Гарантии бесперебойной, безошибочной или безопасной работы Сайта</li>
                  <li>Гарантии точности, полноты или актуальности информации на Сайте</li>
                </ul>
                <p className="body-medium">
                  Мы не гарантируем, что Сайт будет доступен в любое время или что он будет свободен от вирусов или других вредоносных компонентов.
                </p>
              </section>

              <section className="legal-section">
                <h2 className="heading-2">9. Ограничение ответственности</h2>
                <p className="body-medium">
                  В максимальной степени, разрешенной применимым законодательством, AGK Commerce, его директора, сотрудники, партнеры и поставщики не несут ответственности за любые прямые, косвенные, случайные, особые, штрафные или последующие убытки, возникающие в результате:
                </p>
                <ul className="body-medium legal-list">
                  <li>Использования или невозможности использования Сайта</li>
                  <li>Любых ошибок или упущений в содержании Сайта</li>
                  <li>Несанкционированного доступа к нашим серверам или персональным данным</li>
                  <li>Прерывания или прекращения передачи данных</li>
                  <li>Любого другого взаимодействия с Сайтом</li>
                </ul>
                <p className="body-medium">
                  Некоторые юрисдикции не допускают ограничения или исключения ответственности, поэтому вышеуказанные ограничения могут не применяться к вам.
                </p>
              </section>

              <section className="legal-section">
                <h2 className="heading-2">10. Возмещение убытков</h2>
                <p className="body-medium">
                  Вы соглашаетесь защищать, возмещать убытки и ограждать AGK Commerce, его аффилированных лиц, директоров, сотрудников и агентов от любых претензий, убытков, обязательств и расходов (включая разумные гонорары адвокатов), возникающих в результате:
                </p>
                <ul className="body-medium legal-list">
                  <li>Вашего использования Сайта</li>
                  <li>Нарушения вами настоящих Условий</li>
                  <li>Нарушения вами прав третьих лиц</li>
                  <li>Любого Пользовательского контента, который вы предоставляете</li>
                </ul>
              </section>

              <section className="legal-section">
                <h2 className="heading-2">11. Изменения условий</h2>
                <p className="body-medium">
                  Мы оставляем за собой право изменять настоящие Условия в любое время. Обновления будут опубликованы на этой странице с указанием даты последнего изменения. Существенные изменения могут быть дополнительно доведены до вашего сведения через Сайт или по электронной почте.
                </p>
                <p className="body-medium">
                  Ваше дальнейшее использование Сайта после публикации изменений будет означать ваше согласие с обновленными Условиями. Если вы не согласны с новыми Условиями, пожалуйста, прекратите использование Сайта.
                </p>
              </section>

              <section className="legal-section">
                <h2 className="heading-2">12. Прекращение использования</h2>
                <p className="body-medium">
                  Мы оставляем за собой право в любое время и по любой причине приостановить или прекратить ваш доступ к Сайту без предварительного уведомления, если мы считаем, что вы нарушили настоящие Условия.
                </p>
                <p className="body-medium">
                  При прекращении использования все лицензии и права, предоставленные вам в рамках настоящих Условий, немедленно прекращаются.
                </p>
              </section>

              <section className="legal-section">
                <h2 className="heading-2">13. Применимое право и разрешение споров</h2>
                <p className="body-medium">
                  Настоящие Условия регулируются и толкуются в соответствии с законодательством Республики Беларусь без учета положений о коллизии правовых норм.
                </p>
                <p className="body-medium">
                  Любые споры, возникающие из настоящих Условий или в связи с ними, будут решаться путем переговоров. В случае невозможности достижения согласия споры подлежат разрешению в компетентных судах Республики Беларусь.
                </p>
              </section>

              <section className="legal-section">
                <h2 className="heading-2">14. Делимость положений</h2>
                <p className="body-medium">
                  Если какое-либо положение настоящих Условий будет признано недействительным или не имеющим юридической силы, это не влияет на действительность остальных положений. Недействительное положение будет заменено действительным, которое наиболее близко по смыслу к первоначальному намерению сторон.
                </p>
              </section>

              <section className="legal-section">
                <h2 className="heading-2">15. Полнота соглашения</h2>
                <p className="body-medium">
                  Настоящие Условия вместе с Политикой конфиденциальности представляют собой полное соглашение между вами и AGK Commerce в отношении использования Сайта и заменяют все предыдущие соглашения или договоренности.
                </p>
              </section>

              <section className="legal-section">
                <h2 className="heading-2">16. Контактная информация</h2>
                <p className="body-medium">
                  Если у вас есть вопросы относительно настоящих Условий использования, пожалуйста, свяжитесь с нами:
                </p>
                <div className="legal-contact">
                  <p className="body-medium"><strong>Email:</strong> edgekeycommerce@gmail.com</p>
                  <p className="body-medium"><strong>Телефон:</strong> +375 (29) 820-71-89</p>
                </div>
                <p className="body-medium">
                  Мы будем рады ответить на ваши вопросы и помочь разрешить любые проблемы.
                </p>
              </section>

              <div className="legal-footer">
                <Link to="/" className="btn-secondary">
                  Вернуться на главную
                </Link>
              </div>
            </div>
          </AnimatedSection>
        </div>
      </main>
    </div>
  );
};

export default TermsOfUsePage;
